import React from "react";
import { FormattedMessage as FM } from "react-intl";
import { NavLink } from "react-router-dom";
import { Container, Divider, Header, Image } from "semantic-ui-react";

import codeSpringLogo from "../../static/images/codespring.jpg";
import proteoLogo from "../../static/images/proteo.jpg";
import ItalicFM from "../../util/styledMessages/ItalicFM";

const WelcomeInformation: React.FC = () => {
    return (
        <>
            <Header as="h1">
                <FM id="menu.title" />
            </Header>

            <Container fluid>
                <FM id="home.sideText1" />
            </Container>
            <Header as="h3">
                <ItalicFM id="home.sideText2" showColon />
            </Header>
            <Container fluid>
                <FM id="home.sideText3" />
            </Container>
            <Container fluid>
                <FM id="home.sideText4" />
            </Container>
            <Header as="h3">
                <ItalicFM id="home.sideText5" showColon />
            </Header>
            <Container fluid>
                <FM id="home.sideText6" />
            </Container>
            <Divider />

            <Container textAlign="center">
                <Image href="https://www.codespring.ro" size="tiny" src={codeSpringLogo} />
                <Container as={NavLink} className="hoverLink" to="https://www.codespring.ro">
                    https://www.codespring.ro
                </Container>

                <Image href="http://www.proteo.cj.edu.ro" size="tiny" src={proteoLogo} />
                <Container as={NavLink} className="hoverLink" to="http://www.proteo.cj.edu.ro">
                    http://www.proteo.cj.edu.ro
                </Container>
            </Container>
            <Divider />

            <Container textAlign="center">
                <FM id="home.footer1" />
            </Container>
            <Container textAlign="center">
                <FM id="home.footer2" />
            </Container>
        </>
    );
};

export default WelcomeInformation;
